import {
  REPORT_LOAD,
  REPORT_RESET,
  REPORT_STALE,
  REPORT_LOADING,
  REPORT_TEST_UPDATE,
} from "../actions/types";

const initialState = {
  test: null,
  error: null,
  response: [],
  loading: false,
  isStale: false,
  reportResponses: [],
};

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REPORT_LOAD:
      // error defaults to null so a previous fetch's error doesn't stick around on a successful
      // load (the success payload never carries its own `error` key) - the error-case dispatch
      // still wins here since its `error` key comes after in the spread.
      return { ...state, error: null, ...payload, loading: false, isStale: false };
    case REPORT_STALE:
      return { ...state, isStale: true };
    case REPORT_RESET:
      return { ...state, ...initialState };
    case REPORT_LOADING:
      return { ...state, loading: payload, error: null };
    case REPORT_TEST_UPDATE:
      return { ...state, test: payload };
    default:
      return state;
  }
};

export default reportReducer;
